import type { SVGProps } from 'react';
const SvgVerticalAlignTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#vertical_align_top_svg__a)">
      <path fill="currentColor" d="M8 11h3v10h2V11h3l-4-4-4 4ZM4 3v2h16V3H4Z" />
    </g>
    <defs>
      <clipPath id="vertical_align_top_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVerticalAlignTop;
